import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  setToast
} from '../../actions/common'
import WithExport from '../../components/Common/WithExport'

export default function WithConnectedExport (Component) {
  // eslint-disable-next-line
  class WithConnectedExportClz  extends WithExport {
    render () {
      return (
        <div>
          <Component
            key='siblingComp'
            ref={(elem) => (this.component = elem)}
            openExportModal={this.openExportModal.bind(this)}
            closeExportModal={this.closeExportModal.bind(this)}
            {...this.props}
          />
        </div>
      )
    }
  }

  const mapStateToProps = (state, ownProps) => {
    return {}
  }

  const mapDispatchToProps = (dispatch) => {
    const exportActions = {
      setToast
    }

    return {
      exportActions: {
        ...bindActionCreators(exportActions, dispatch)
      }
    }
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithConnectedExportClz)
}
